import { createSlice } from '@reduxjs/toolkit';

const foodOrderSlice = createSlice({
    name: "foodOrders",
    initialState: {
        orderList: []
    },
    reducers: {
        addFoodOrder(state, action) {
            const { id, foods_number, Client, food } = action.payload;
            const existingOrder = state.orderList.find(order => order.id === id);
            console.log(existingOrder);
            if (existingOrder) {
                existingOrder.foods_number += foods_number;
            } else {
                state.orderList.push({ id, foods_number, Client, food });
            }
            console.log(state);
        },
        removeFoodOrder(state, action) {
            const { food } = action.payload;
            state.orderList = state.orderList.filter(order => order.food !== food)
        },
        updateFoodOrderCount(state, action) {
            const { food, count } = action.payload;
            const existingOrder = state.orderList.find(order => order.food === food);
            if (existingOrder) {
                existingOrder.count = count;
            }


        }
    }
})

export default foodOrderSlice.reducer;
export const { addFoodOrder, removeFoodOrder, updateFoodOrderCount } = foodOrderSlice.actions;
